class AddressSuggest {
    baseUrl;
    token;

    constructor(
        baseUrl,
        token,
    ) {
        this.baseUrl = baseUrl;
        this.token = token;
    }

    composeRequestUrl(query) {
        return this.baseUrl + '?type=adresnimisto&q=' + encodeURIComponent(query);
    }

    /**
     * @param {string} query
     * @return {Promise<AddressSuggestResponse>}
     */
    async suggest(query) {
        const requestUrl = this.composeRequestUrl(query);
        const response = await fetch(requestUrl, {
            method: 'GET',
            cache: 'no-cache',
            credentials: 'omit',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
            },
            referrer: 'client'
        });

        if (!response.ok) {
            const responseText = await response.json();
            throw new Error(`AddressSuggest: Při komunikaci s endpointem došlo k chybě: ${response.statusText} ${responseText.message}`);
        }

        return await response.json();
    }

}

class AddressSuggestHit {
    /** @var {string} */
    id;
    /** @var {number} */
    kod;
    /** @var {string} */
    typ;
    /** @var {string} */
    text;
    /** @var {string} */
    nazev;
    /** @var {number} */
    uliceKod;
    /** @var {number} */
    castObceKod;
    /** @var {string} */
    castObceNazev;
    /** @var {number} */
    obecKod;
    /** @var {string} */
    obecNazev;
    /** @var {number} */
    okresKod;
    /** @var {string} */
    okresNazev;
    /** @var {number} */
    vuscKod;
    /** @var {string} */
    vuscNazev;
    /** @var {number} */
    psc;
    /** @var {string} */
    bodSjtsk;
    /** @var {string} */
    bodWgs84;
}


class AddressSuggestResponse {
    /** @var {number} */
    totalCount;
    /** @var {boolean} */
    totalCountIsApproximation;
    /** @var {Array<AddressSuggestHit>} */
    hits;
}